import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { CatImpuestos2, CatTipoFactor, ImpuestoConcepto } from '../../../../shared/models';
import { map } from 'rxjs';
import { SharedService } from '../../../../shared/services/shared.service';
import { FacturacionService } from '../../../../shared/services/facturacion.service';

@Component({
  selector: 'app-form-impuestos-conceptos',
  standalone: false,
  templateUrl: './form-impuestos-conceptos.component.html',
  styleUrl: './form-impuestos-conceptos.component.scss'
})
export class FormImpuestosConceptosComponent implements OnInit {
  public formImpuestos: FormGroup;
  public formImpuesto: FormGroup;
  public catImpuestos: CatImpuestos2[] = [];
  public tipoImpuesto: string = "";
  public trasladoRetencion: string = "";
  public impuestoTemporal!: ImpuestoConcepto;
  public tasaOCuotaTemporal: number = 0;
  public catTipoFactor: CatTipoFactor[] = [];
  public isTasaReadOnly: boolean = false;
  public pAplicacion: number = 100;

  @Input() public baseConcepto!: number;
  @Output() public sendImpuestos: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    
      private facturacionService: FacturacionService,
    private sharedService: SharedService
  ) {
    const catTipoFactorStorage: any = sessionStorage.getItem('CatTipoFactor');
    this.catTipoFactor = JSON.parse(catTipoFactorStorage);

    this.formImpuestos = new FormGroup({
      traslados: new FormArray([]),
      retenciones: new FormArray([])
    });

    this.initFormImpuesto();
  }

  ngOnInit(): void {
    this.facturacionService
      .catalogoImpuestos()
      .pipe(
        map((response) =>
          response.filter((item) => ({
            cImpuesto: item.cImpuesto,
            descripcion: item.descripcion,
            retencion: item.retencion,
            traslado: item.traslado,
            localofederal: item.localofederal,
          }))
        )
      )
      .subscribe((datos) => {
        this.catImpuestos = datos;
      });
  }

  public initFormImpuesto(): void {
    this.formImpuesto = new FormGroup({
      base: new FormControl(),
      impuesto: new FormControl(null, [Validators.required]),
      tipoFactor: new FormControl(null, [Validators.required]),
      tasaoCuota: new FormControl<number>(null, [Validators.required]),
      importe: new FormControl()
    });
    this.pAplicacion = 100;
    this.trasladoRetencion = "";
    this.tipoImpuesto = "";
  }

  public selectImpuesto(): void {
    let impuestoSeleccionado: any = this.catImpuestos.find((elem) => elem.cImpuesto === this.formImpuesto.value['impuesto']);
    this.impuestoTemporal = impuestoSeleccionado;
    this.tipoImpuesto = impuestoSeleccionado.localofederal;

    if (this.formImpuesto.value['impuesto'] === '002') {
      this.formImpuesto.controls['tasaoCuota'].setValue(0.16);
      this.setTasaOCuota();
    } else {
      this.formImpuesto.controls['tasaoCuota'].setValue(null);
    }

    this.trasladoRetencion = 'traslado';
    this.formImpuesto.controls['tipoFactor'].setValue('Tasa');
  }

  public selectTipoFactor(): void {
    switch (this.formImpuesto.value['tipoFactor']) {
      case 'Tasa':
        this.isTasaReadOnly = false;
        break;
      case 'Cuota':
        this.isTasaReadOnly = false;
        break;
      case 'Exento':
        this.formImpuesto.controls['tasaoCuota'].setValue(0);
        this.isTasaReadOnly = true;
        break;
    }
  }

  public setTasaOCuota(): void {
    this.tasaOCuotaTemporal = this.formImpuesto.value['tasaoCuota'];
  }

  public calcularPAplicacion(event: any): void {
    this.pAplicacion = event.target.value;
    this.formImpuesto.controls['tasaoCuota'].setValue(this.tasaOCuotaTemporal * this.pAplicacion / 100);
  }

  public agregarImpuesto(): void {
    if (this.baseConcepto) {
      if (this.formImpuesto.valid) {
        if (this.trasladoRetencion === 'traslado') {
          this.formImpuesto.controls['base'].setValue(this.baseConcepto);
          this.formImpuesto.controls['importe'].setValue(this.calcularImporte(this.formImpuesto.value['base'], this.formImpuesto.value['tasaoCuota'], this.formImpuesto.value['tipoFactor']));

          const isExistImpuesto = this.getTraslados().value.some(item =>
            item.tasaoCuota === this.formImpuesto.value['tasaoCuota'] &&
            item.tipoFactor === this.formImpuesto.value['tipoFactor'] &&
            item.impuesto === this.formImpuesto.value['impuesto']
          );

          if (!isExistImpuesto) {
            this.getTraslados().push(this.formImpuesto);
            this.sendImpuestos.emit(this.formImpuestos.value);
            this.initFormImpuesto();
          } else {
            this.sharedService.eventCreateToaster.emit({
              header: '¡Error!',
              message: 'Ya existe un impuesto con esta información.',
              type: 'error',
              delay: 6000
            });
          }
        } else {
          this.formImpuesto.controls['base'].setValue(this.baseConcepto);
          this.formImpuesto.controls['importe'].setValue(this.calcularImporte(this.formImpuesto.value['base'], this.formImpuesto.value['tasaoCuota'], this.formImpuesto.value['tipoFactor']));

          const isExistImpuesto = this.getTraslados().value.some(item =>
            item.tasaoCuota === this.formImpuesto.value['tasaoCuota'] &&
            item.tipoFactor === this.formImpuesto.value['tipoFactor'] &&
            item.impuesto === this.formImpuesto.value['impuesto']
          );

          if (!isExistImpuesto) {
            this.getRetenciones().push(this.formImpuesto);
            this.sendImpuestos.emit(this.formImpuestos.value);
            this.initFormImpuesto();
          } else {
            this.sharedService.eventCreateToaster.emit({
              header: '¡Error!',
              message: 'Ya existe un impuesto con esta información.',
              type: 'error',
              delay: 6000
            });
          }
        }
      } else {
        this.sharedService.eventCreateToaster.emit({
          header: '¡Error!',
          message: 'Completa los campos obligatorios para agregar el impuesto.',
          type: 'error',
          delay: 6000
        });
      }
    } else {
      this.sharedService.eventCreateToaster.emit({
        header: '¡Error!',
        message: 'Completa tu concepto para poder agregarle un impuesto.',
        type: 'error',
        delay: 6000
      });
    }
  }

  public getTraslados(): FormArray {
    return this.formImpuestos.get('traslados') as FormArray
  }

  public removeTraslado(indice: number) : void {
    this.getTraslados().removeAt(indice);
    this.sendImpuestos.emit(this.formImpuestos.value);
  }

  public getRetenciones(): FormArray {
    return this.formImpuestos.get('retenciones') as FormArray
  }

  public removeRetencion(indice: number) : void {
    this.getRetenciones().removeAt(indice);
    this.sendImpuestos.emit(this.formImpuestos.value);
  }

  public calcularImporte(base: number, tasaOcuota: number, tipoFactor: string): number {
    let importe;
    if (tipoFactor === "Tasa") {
      importe = base * tasaOcuota;
    } else {
      importe = tasaOcuota;
    }

    return importe;
  }

  public setTrasRet(event: any): void {
    this.trasladoRetencion = event.target.value;
  }
}
